module.exports = __webpack_public_path__ + "img/20200512_163147.fd256627.jpg";